module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "upload__button-row"
  }, [_c('UploadManagerButton', {
    attrs: {
      "progress": _vm.generalProgress,
      "uploads-count": _vm.uploads.length,
      "button-text": _vm.uploadsButtonText,
      "is-open": _vm.isUploadsOpen,
      "general-status": _vm.generalStatus
    },
    on: {
      "click": _vm.onUploadsButtonClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-upload open__text-icon mr-20",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.unfinishedUploads.length || _vm.isUnfinishedUploadsOpen) ? _c('UnfinishedUploadsButton', {
    attrs: {
      "uploads-count": _vm.unfinishedUploads.length,
      "button-text": _vm.unfinishedButtonText,
      "is-open": _vm.isUnfinishedUploadsOpen
    },
    on: {
      "click": _vm.onUnfinishedButtonClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "upload__lists-wrap"
  }, [_c('UploadsList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUploadsOpen),
      expression: "isUploadsOpen"
    }],
    attrs: {
      "uploads": _vm.uploads,
      "is-open": _vm.isUploadsOpen
    },
    on: {
      "stop": _vm.onStopUploadClicked,
      "resume": _vm.onResumeUploadClicked,
      "pause": _vm.onPauseUploadClicked,
      "retry": _vm.onRetryUploadClicked,
      "remove": _vm.onRemoveClicked,
      "hide": _vm.onHideClicked
    }
  }), _vm._v(" "), _c('UnfinishedList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUnfinishedUploadsOpen),
      expression: "isUnfinishedUploadsOpen"
    }],
    attrs: {
      "is-open": _vm.isUnfinishedUploadsOpen,
      "unfinished-uploads": _vm.unfinishedUploads
    },
    on: {
      "file-selected": _vm.onFileReselected,
      "hide": _vm.onUnfinishedHideClicked,
      "remove-clicked": _vm.onUnfinishedRemoveClicked
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2967b05e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadManager/UploadManager.vue
// module id = 849
// module chunks = 0